import { FC, PropsWithChildren } from 'react';
import { RowCard } from '@/components/RowCard';

interface IFAQAccordionProps {
  title: string;
}

export const FAQAccordion: FC<PropsWithChildren<IFAQAccordionProps>> = ({
  title,
  children,
}) => {
  return (
    <RowCard
      classNames={{
        root: '!rounded-none !bg-neutral-filled-primary-enabled !px-4 !py-2.5',
        rootWrapper:
          'cursor-pointer overflow-hidden rounded-md border border-gray-solid-primary-enabled',
        title: '!text-xs !font-demibold',
        expandedContent:
          '!my-0 !bg-transparent !p-4 !text-gray-filled-primary-enabled',
        clickIconWrapper: '!text-gray-filled-primary-enabled',
      }}
      title={title}
    >
      {children}
    </RowCard>
  );
};
